import api from '@/services/api'

export const getAllStatus = async except => {
    try {
        const response = await api.get('status', { params: { except } })
        return response.data.data
    } catch (e) {
        console.error(e)
    }
}
